import React, { useState, useEffect, useContext, useRef } from "react";
import "../../../../constants/report.css";
import axios from "axios";
import { AuthContext } from "../../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../../contexts/ContextProvider";
import { Loader } from "../../../../components";
import { formatDate } from "../../../../constants/helper";
import {
  Box,
  ButtonGroup,
  Button,
  Autocomplete,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from "@mui/material";
import { Container, Form, Row, Col, Table } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import jsPDF from "jspdf";
import { useDownloadExcel } from "react-export-table-to-excel";
import SearchIcon from "@mui/icons-material/Search";
import PrintIcon from "@mui/icons-material/Print";
import { useReactToPrint } from "react-to-print";
import useScreenWidth from "../../../../hooks/useScreenWidth";

const LaporanPembayaranHutang = () => {
  const screenSize = useScreenWidth();
  const tableRef = useRef(null);
  const { user, dispatch, setting } = useContext(AuthContext);
  const reportTemplateRef = useRef(null);
  let nowDate = new Date();
  let [sampaiTanggal, setSampaiTanggal] = useState(
    new Date(user.tutupperiode.sampaiTanggal)
  );
  let [dariTanggal, setDariTanggal] = useState(
    new Date(user.tutupperiode.dariTanggal)
  );
  const [kodeCabang, setKodeCabang] = useState("");
  const [namaCabang, setNamaCabang] = useState("");
  const [kodeCOA, setKodeCOA] = useState("");
  const [kodeSupplier, setKodeSupplier] = useState("");

  const [cabangs, setCabangs] = useState([]);
  const [coas, setCoas] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [persenLoading, setPersenLoading] = useState("0");
  const [lapHutangJatuhTempos, setLapHutangJatuhTempos] = useState([]);
  const [previewPdf, setPreviewPdf] = useState(false);
  const [isCetakExcel, setIsCetakExcel] = useState(false);
  const [error, setError] = useState(false);

  const [filter, setFilter] = useState("PER SUPPLIER");

  const handleChangeFilter = (event) => {
    setFilter(event.target.value);
    setPreviewPdf(false);
  };

  let cabangOptions = cabangs.map((cabang) => ({
    label: `${cabang.id} - ${cabang.namaCabang}`,
    id: `${cabang.id} - ${cabang.namaCabang}`,
  }));

  let coaOptions = coas.map((coa) => ({
    label: `${coa.kodeCOA} - ${coa.namaCOA}`,
  }));
  let supplierOptions = suppliers.map((supplier) => ({
    label: `${supplier.kodeSupplier} - ${supplier.namaSupplier}`,
  }));

  useEffect(() => {
    getCoaData();
    getSupplierData();
  }, []);

  const getCoaData = async () => {
    const response = await axios.post(`${tempUrl}/coas`, {
      _id: user.id,
      token: user.token,
    });
    setCoas(response.data);
  };

  const getSupplierData = async () => {
    const response = await axios.post(`${tempUrl}/suppliers`, {
      _id: user.id,
      token: user.token,
    });
    setSuppliers(response.data);
  };

  const generatePDF = useReactToPrint({
    content: () => reportTemplateRef.current,
    documentTitle: "LaporanPembayaranHutang",
  });

  const tampilPdf = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity()) {
      setLoading(true);
      let tempPersenLoading = parseInt(persenLoading);

      setTimeout(() => {
        tempPersenLoading += 40;
        setPersenLoading(tempPersenLoading.toString());
      }, "1000");

      let laporanPembayaranHutang = await axios.post(
        `${tempUrl}/laporanPembayaranHutang`,
        {
          dariTanggal,
          sampaiTanggal,
          filter,
          kodeCOA: kodeCOA.split(" ", 1)[0],
          kodeSupplier: kodeSupplier.split(" ", 1)[0],
          kodeCabang,
          _id: user.id,
          token: user.token,
        }
      );
      setLapHutangJatuhTempos(laporanPembayaranHutang.data);
      setPreviewPdf(!previewPdf);
      setLoading(false);
      setTimeout(() => {
        tempPersenLoading = 0;
        setPersenLoading(tempPersenLoading.toString());
      }, "2000");
    }
  };

  useEffect(() => {
    getCabangsData();
    if (user.tipeUser !== "OWNER/DIREKSI") {
      setKodeCabang(user.cabang.id);
      setNamaCabang(`${user.cabang.id} - ${user.cabang.namaCabang}`);
    }
  }, []);

  const getCabangsData = async () => {
    const response = await axios.post(`${tempUrl}/cabangs`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setCabangs(response.data);
  };

  const tableText = {
    letterSpacing: "0.01px",
  };

  const textBold = {
    fontWeight: 700,
    border: "1px solid black",
  };

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  const textNumberRight = {
    textAlign: "right",
    border: "1px solid black",
  };

  const textNumberRightBold = {
    textAlign: "right",
    fontWeight: 700,
    border: "1px solid black",
  };

  const list = [];

  let tempTotalTotalBayar = 0;

  Object.entries(lapHutangJatuhTempos).map(([supplierTitle, stokRows]) => {
    list.push(
      <tr style={{ ...tableText, fontWeight: "bold" }}>
        <td
          style={{ paddingLeft: "15px", border: "1px solid black" }}
          colSpan={5}
        >
          {filter === "PER SUPPLIER" && "Supplier :"}
          {filter === "PER TANGGAL" && "Tanggal :"}
          {filter === "PER ACCOUNT" && "Account :"}
          {supplierTitle}
        </td>
      </tr>
    );

    let tempSubtotalTotalBayar = 0;

    stokRows.map((row, index) => {
      tempSubtotalTotalBayar += row.totalBayar;
      tempTotalTotalBayar += row.totalBayar;
      list.push(
        <tr style={tableText}>
          <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
            {row.pembelian.noNotaPembelian}
          </td>
          <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
            {formatDate(row.tglPembayaranHutang)}
          </td>
          <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
            {row.coa.kodeCOA} - {row.coa.namaCOA}
          </td>
          <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
            TITIPAN
          </td>
          <td style={textNumberRight}>
            {isCetakExcel === false
              ? row.totalBayar.toLocaleString("en-EN")
              : row.totalBayar}
          </td>
        </tr>
      );
    });

    list.push(
      <tr style={{ ...tableText, fontWeight: "bold" }}>
        <td
          style={{ paddingLeft: "15px", border: "1px solid black" }}
          colSpan={4}
        >
          Sub Total : {supplierTitle}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? tempSubtotalTotalBayar.toLocaleString("en-EN")
            : tempSubtotalTotalBayar}
        </td>
      </tr>
    );
  });

  list.push(
    <tr style={{ ...tableText, fontWeight: "bold" }}>
      <td
        style={{ paddingLeft: "15px", border: "1px solid black" }}
        colSpan={4}
      >
        Total :
      </td>
      <td style={textNumberRight}>
        {isCetakExcel === false
          ? tempTotalTotalBayar.toLocaleString("en-EN")
          : tempTotalTotalBayar}
      </td>
    </tr>
  );

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "LaporanPembayaranHutang",
    sheet: "LaporanPembayaranHutang",
  });

  if (loading) {
    return <Loader persenLoading={persenLoading} />;
  }

  return (
    <Container>
      <h3>Laporan</h3>
      <h5 style={{ fontWeight: 400 }}>Laporan Pembayaran Hutang</h5>
      <hr />
      <Box sx={spacingTop}>
        <Form onSubmit={tampilPdf}>
          <Row>
            <FormControl sx={{ marginTop: 1 }}>
              <FormLabel id="demo-controlled-radio-buttons-group">
                Filter
              </FormLabel>
              <RadioGroup
                row
                aria-labelledby="demo-controlled-radio-buttons-group"
                name="controlled-radio-buttons-group"
                defaultValue="PER SUPPLIER"
                value={filter}
                onChange={handleChangeFilter}
              >
                <FormControlLabel
                  value="PER SUPPLIER"
                  control={<Radio />}
                  label="Per Supplier"
                />
                <FormControlLabel
                  value="PER TANGGAL"
                  control={<Radio />}
                  label="Per Tanggal"
                />
                <FormControlLabel
                  value="PER ACCOUNT"
                  control={<Radio />}
                  label="Per Account"
                />
              </RadioGroup>
            </FormControl>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Cabang :
                </Form.Label>
                <Col sm="8">
                  {user.tipeUser === "OWNER/DIREKSI" ? (
                    <Autocomplete
                      size="small"
                      disablePortal
                      id="combo-box-demo"
                      options={cabangOptions}
                      renderInput={(params) => (
                        <TextField
                          error={user.tipeUser !== "OWNER/DIREKSI" && error && kodeCabang.length === 0}
                          size="small"
                          placeholder="SEMUA CABANG"
                          {...params}
                        />
                      )}
                      onChange={(e, value) => {
                        if (value) {
                          setKodeCabang(value.id.split(" ", 1)[0]);
                          setNamaCabang(value.id);
                        } else {
                          setKodeCabang("");
                          setNamaCabang("");
                        }
                        setPreviewPdf(false);
                      }}
                      defaultValue={kodeCabang}
                    />
                  ) : (
                    <Form.Control value={kodeCabang} disabled readOnly />
                  )}
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Dari :
                </Form.Label>
                <Col sm="8">
                  <DatePicker
                    required
                    dateFormat="dd/MM/yyyy"
                    selected={dariTanggal}
                    customInput={<Form.Control required />}
                    onChange={(date) => {
                      setDariTanggal(date);
                      setPreviewPdf(false);
                    }}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Sampai :
                </Form.Label>
                <Col sm="8">
                  <DatePicker
                    required
                    dateFormat="dd/MM/yyyy"
                    selected={sampaiTanggal}
                    customInput={<Form.Control required />}
                    onChange={(date) => {
                      setSampaiTanggal(date);
                      setPreviewPdf(false);
                    }}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Account :
                </Form.Label>
                <Col sm="8">
                  <Autocomplete
                    size="small"
                    disablePortal
                    id="combo-box-demo"
                    options={coaOptions}
                    renderInput={(params) => (
                      <TextField
                        placeholder="SEMUA ACCOUNT"
                        size="small"
                        {...params}
                      />
                    )}
                    onChange={(e, value) => {
                      if (value) {
                        setKodeCOA(value.label);
                      } else {
                        setKodeCOA("");
                      }
                      setPreviewPdf(false);
                    }}
                    value={kodeCOA}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Supplier :
                </Form.Label>
                <Col sm="8">
                  <Autocomplete
                    size="small"
                    disablePortal
                    id="combo-box-demo"
                    options={supplierOptions}
                    renderInput={(params) => (
                      <TextField
                        placeholder="SEMUA SUPPLIER"
                        size="small"
                        {...params}
                      />
                    )}
                    onChange={(e, value) => {
                      if (value) {
                        setKodeSupplier(value.label);
                      } else {
                        setKodeSupplier("");
                      }
                      setPreviewPdf(false);
                    }}
                    value={kodeSupplier}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Button
            variant="contained"
            startIcon={<SearchIcon />}
            type="submit"
            style={{ marginTop: "20px" }}
          >
            LIHAT
          </Button>
        </Form>
      </Box>

      {previewPdf && (
        <div style={{ marginTop: "10px" }}>
          <ButtonGroup variant="outlined" color="secondary">
            <Button startIcon={<PrintIcon />} onClick={generatePDF}>
              PDF
            </Button>
            <Button
              startIcon={<SearchIcon />}
              onClick={() => {
                setIsCetakExcel(true);
                setTimeout(() => {
                  onDownload();
                }, "1000");
              }}
            >
              Excel
            </Button>
          </ButtonGroup>
        </div>
      )}
      <div ref={reportTemplateRef} id="content" style={pdfContainer}>
        <div style={{ visibility: previewPdf === true ? "visible" : "hidden" }}>
          <p>
            {setting.namaPerusahaan} - {setting.alamatPerusahaan}
          </p>
          <p>({setting.kabupatenPerusahaan})</p>
          <p>{setting.kotaPerusahaan}</p>
          <p>NO. TELP. {setting.teleponPerusahaan}</p>
          <p>
            Dicetak Oleh: {user.username} | Tanggal:
            {` ${nowDate.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${(nowDate.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${nowDate.getFullYear()} `}{" "}
            | Jam:{" "}
            {` ${nowDate.getHours().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}:${(nowDate.getMinutes() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}:${nowDate.getSeconds().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })} `}
          </p>
          <h5 style={{ textAlign: "center", fontWeight: "700" }}>
            Laporan Pembayaran Hutang
          </h5>
          <p>
            Dari Tanggal :
            {` ${dariTanggal.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${(dariTanggal.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${dariTanggal.getFullYear()}`}
          </p>
          <p>
            Sampai Tanggal :
            {` ${sampaiTanggal.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${(sampaiTanggal.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${sampaiTanggal.getFullYear()}`}
          </p>
          <p>Supplier : {kodeSupplier ? kodeSupplier : "SEMUA"}</p>
          <p>Cabang : {namaCabang || "SEMUA CABANG"}</p>
          <p></p>
          <table class="styled-table" ref={tableRef}>
            <thead>
              <tr>
                <th style={{ border: "1px solid black" }}>NO. NOTA</th>
                <th style={{ border: "1px solid black" }}>TG. BAYAR</th>
                <th style={{ border: "1px solid black" }}>ACCOUNT</th>
                <th style={{ border: "1px solid black" }}>KETERANGAN</th>
                <th style={{ border: "1px solid black" }}>JUMLAH</th>
              </tr>
            </thead>
            <tbody>{list}</tbody>
          </table>
        </div>
      </div>
    </Container>
  );
};

export default LaporanPembayaranHutang;

const spacingTop = {
  mt: 4,
};

const pdfContainer = {
  padding: "20px",
  letterSpacing: "0.01px",
  fontSize: "10px",
  fontFamily: "sans-serif",
  width: "1000px",
};
